import React, { useContext } from "react";
import Actions from "./Actions";
import { Box, Typography } from "@mui/material";
import { ProjectContext } from "../../../AppContext/ProjectContext";
import { Assignment } from "@mui/icons-material";

export default function ConsolidatedActions() {
  const { actions } = useContext(ProjectContext);
  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5, px: 1 }}>
        <Assignment fontSize="small" color="primary" />
        <Typography variant="subtitle2" fontWeight={700} color="#1a237e">
          Consolidated Actions
        </Typography>
      </Box>
      <Actions actions={actions} />
    </Box>
  );
}
